import { render } from "./DashboardWorkflowCard.vue?vue&type=template&id=316802b0&scoped=true"
import script from "./DashboardWorkflowCard.vue?vue&type=script&lang=js"
export * from "./DashboardWorkflowCard.vue?vue&type=script&lang=js"

import "./DashboardWorkflowCard.vue?vue&type=style&index=0&id=316802b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316802b0"]])

export default __exports__